import React from 'react';
import {
    bbFindEntityWithinPortfolioOrSelf, bbGetColorFromAPIFidelity,
    bbGetColorFromAPIFidelityCategoryId,
    bbGetDisplayNameFromAPIFidelity,
    bbGetDisplayNameFromAPIFidelityCategoryId,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor,
} from "../../../util/bbHelpers";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {useSelector} from "react-redux";
import {Badge} from "reactstrap";


const fidelityBadgeExamples = [
    {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-highest"}>Very Low Fidelity</Badge></p>,
    text: null,},
    {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-high"}>Low Fidelity</Badge></p>,
        text: null,},
    {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-medium"}>Medium Fidelity</Badge></p>,
        text: null,},
    {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-low"}>High Fidelity</Badge></p>,
        text: null,},
    {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-lowest"}>Very High Fidelity</Badge></p>,
        text: null,},
]
const BRFidelityBadge = (props) => {

    // const { entityId } = props;
    const { cycleObject } = props;

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // const { portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    //
    // const entityIdToUse = entityId ? entityId : entityInView;
    //
    // const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    // // const entity = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].entities ? portfolios[customerIdToUse].entities[entityId] : null;
    //
    // const entity = bbFindEntityWithinPortfolioOrSelf(entityIdToUse, portfolios, customerIdToUse);
    // const lastCycle = entity ? entity.last_cycle : null

    // console.log("cycleObject is", cycleObject);

    const confidenceLow = cycleObject ? parseFloat(cycleObject.confidence_low).toFixed(1) : null;
    const confidenceHigh = cycleObject ? parseFloat(cycleObject.confidence_high).toFixed(1) : null;

    let fidelityCategoryDisplayName = "";
    let fidelityCategoryColor = "";
    if (cycleObject && cycleObject.fidelity) {
        fidelityCategoryDisplayName = bbGetDisplayNameFromAPIFidelity(cycleObject.fidelity, true);
        fidelityCategoryColor = bbGetColorFromAPIFidelity(cycleObject.fidelity);
    } else {
        console.warn("Invalid cycle object received when looking for fidelity:", cycleObject);
    }


    // const fidelityCategory = bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(confidenceLow, confidenceHigh);
    // const fidelityColor = bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor(confidenceLow, confidenceHigh)

    // console.log("entity", entity, "lastCycle", lastCycle)

    return(
        // <Tooltip title={`${fidelityCategoryDisplayName} score. Risk could be between ${confidenceLow} and ${confidenceHigh}. BreachRisk™ uses a hacker's methodology and is therefore subject to uncertainty. The higher the fidelity, the higher the certainty of our risk measurements. There are many factors that affect fidelity, some of which are environmental in nature or are related to hacker methods and capabilities - and therefore beyond the control of this company.\n`}>
        <Tooltip extra={true}
                 examples={fidelityBadgeExamples}
                 link={`/board/userguide#fidelity`}
                 width={"450px"}
                 heading={"Fidelity Categories"}>
        <span>
                <Badge
                    color={fidelityCategoryColor}
                    >{fidelityCategoryDisplayName}
                </Badge>
              </span>
        </Tooltip>
    )

}

export default BRFidelityBadge;